<template>
  <div>
    <!-- 쿠폰 -->
    <div class="dimed wrap" v-if="!selectExchangeYn">
      <div class="layer">
        <div class="layer__header">
          <div class="lyr-title">{{ $t('Modal.Coupon.msg1') }}</div>
          <div class="ft-point">{{ $t('Modal.Coupon.msg2') }}</div>
        </div>
        <div class="layer__body layer__body_coupon">
          <div class="flex-row">
            <div class="payment-total">
              <dl>
                <dt>{{ $t('Modal.Coupon.msg3') }}</dt>
                <dd class="pay-amount">{{ totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}{{ currUnitText }}</dd>
              </dl>
            </div>
          </div>

          <div class="list-order--coupon scroll-area" id="orderScroll" v-if="couponList.length != 0">
            <div class="coupon-list" style="position: relative; margin-bottom: 1em" v-for="coupon in couponList" :key="coupon">
              <div
                class="not-matched"
                v-if="
                  (coupon.CouponPluList.filter((item) => orgBaskets.filter((item2) => item2.DIS_ITEM_CD == item.GoodsCode).length > 0).length == 0 &&
                    coupon.CouponType == 'EXCHANGE') ||
                  (coupon.CouponType != 'EXCHANGE' && coupon.DiscountValue > totalPrice)
                "
              >
                <span class="msg">{{ $t('Modal.Coupon.msg12') }}</span>
              </div>
              <div class="coupon-item" @mouseup="selectCouponItem(coupon.CouponPublishNo, coupon)" :class="{selected: selectCode == coupon.CouponPublishNo}">
                <span class="ico-checked" v-if="selectCode == coupon.CouponPublishNo">checked</span>
                <div class="coupon-item-top">
                  <div class="coupon-name">{{ coupon.CouponName }}</div>
                  <div class="coupon-type">{{ coupon.CouponType == 'EXCHANGE' ? $t('Modal.Coupon.msg10') : $t('Modal.Coupon.msg11') }}</div>
                </div>
                <div class="coupon-item-bottom">
                  <div class="coupon-date">{{ coupon.ValidStartDate }} ~ {{ coupon.ValidEndDate }}</div>
                  <div class="coupon-discount" v-if="coupon.CouponType != 'EXCHANGE'">
                    {{ coupon.DiscountValue }}{{ coupon.DiscountType == 'FIXED_RATE' ? '%' : currUnitText }} {{ $t('Modal.Coupon.msg4') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="list-order--coupon scroll-area" style="border: none; background-color: #fff" id="orderScroll" v-if="couponList.length == 0">
            <div class="no-data">
              <div class="txt">{{ $t('Modal.Coupon.msg13') }}</div>
              <br />
              <div class="txt">{{ $t('Modal.Coupon.msg7') }}</div>
            </div>
          </div>

          <div class="btn-area" v-if="couponList.length != 0">
            <button class="btn-arr-u btn-anim" @mouseup="scrollMove(-50)">위로</button>
            <button class="btn-arr-d btn-anim" @mouseup="scrollMove(+50)">아래로</button>
          </div>
        </div>
        <div class="layer__button">
          <button class="btn btn--cancel btn-anim" @mouseup="$emit('couponClose')">{{ $t('Modal.Coupon.msg5') }}</button>
          <button class="btn btn--submit btn-anim" :disabled="couponList.length == 0 || selectCode == ''" @mouseup="nextCouponStep()">
            {{ $t('Modal.Coupon.msg6') }}
          </button>
        </div>
      </div>
    </div>

    <!-- 쿠폰 교환 상품 -->
    <div class="dimed wrap" v-if="selectExchangeYn">
      <div class="layer">
        <div class="layer__header">
          <div class="lyr-title">{{ $t('Modal.Coupon.msg8') }}</div>
          <div class="ft-point">{{ $t('Modal.Coupon.msg9') }}</div>
        </div>
        <div class="layer__body layer__body_coupon">
          <div class="coupon-list">
            <div class="coupon-item" style="box-shadow: none; border: 4px solid #eaeaea; margin: 0.9vh 5vw; width: auto; padding: none">
              <div class="coupon-item-top">
                <div class="coupon-name">{{ selectCoupon.CouponName }}</div>
                <div class="coupon-type">{{ selectCoupon.CouponType }}</div>
              </div>
              <div class="coupon-item-bottom">
                <div class="coupon-date">{{ selectCoupon.ValidStartDate }} ~ {{ selectCoupon.ValidEndDate }}</div>
              </div>
            </div>
          </div>

          <div style="height: 0.5em">
            <img style="height: 24px; width: 24px" src="@/assets/images/user/img_bg_arrow_dn.png" alt="" />
          </div>

          <div class="list-order--coupon scroll-area" id="orderScroll">
            <div class="coupon-list" style="position: relative; margin-bottom: 1em" v-for="item in mergeList" :key="item">
              <div class="basket-item" @mouseup="selectItem(item)" :class="{selected: selectItemCode == item.UniqueCode}">
                <span class="ico-checked" v-if="selectItemCode == item.UniqueCode">checked</span>
                <div class="basket-item-left">
                  <div class="basket-prd basket-name">{{ item.ProdName }}</div>
                </div>
                <div class="basket-item-right">
                  <div class="basket-prd basket-sales">{{ item.UnitPrice }}{{ currUnitText }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="btn-area">
            <button class="btn-arr-u btn-anim" @mouseup="scrollMove(-50)">위로</button>
            <button class="btn-arr-d btn-anim" @mouseup="scrollMove(+50)">아래로</button>
          </div>
        </div>
        <div class="layer__button">
          <button class="btn btn--cancel btn-anim" @mouseup="prevCouponStep()">{{ $t('Modal.Coupon.msg5') }}</button>
          <button class="btn btn--submit btn-anim" :disabled="orgBaskets.length == 0 || selectItemCode == ''" @mouseup="nextMembersStep">
            {{ $t('Modal.Coupon.msg6') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'coupon',
  data() {
    return {
      selectCode: '',
      selectItemCode: '',
      selectItemObj: null,
      selectExchangeYn: false,
      selectCoupon: null,
      orgBaskets: this.$store.getters.getOrgBaskets,
      darkModeYn: this.$store.getters.getDarkModeYn,
      couponList: this.membersObj.coupon.CouponList,
    };
  },
  mounted() {},
  props: {
    totalPrice: Number,
    currUnitText: String,
    membersObj: Object,
    posTransaction: Object,
  },
  methods: {
    //exchange type 상품 선택 취소
    prevCouponStep() {
      this.selectExchangeYn = false;
      this.selectItemCode = '';
    },
    //쿠폰 종료
    nextMembersStep() {
      this.$emit('nextMembersStep', this.selectCoupon, this.selectItemObj);
    },
    //쿠폰 선택 종료
    nextCouponStep() {
      if (this.selectCoupon.CouponType === 'EXCHANGE') {
        this.selectExchangeYn = true;
      } else {
        this.$emit('nextMembersStep', this.selectCoupon, null);
      }
      // this.selectExchangeYn = true;
    },
    //excheange type 쿠폰 상품 선택
    selectItem(item) {
      if (this.selectItemCode == item.UniqueCode) {
        this.selectItemCode = '';
        this.selectItemObj = null;
      } else {
        this.selectItemObj = item;
        this.selectItemCode = item.UniqueCode;
      }
    },
    //쿠폰 선택
    selectCouponItem(code, coupon) {
      if (this.selectCode == code) {
        this.selectCode = '';
        this.selectCoupon = null;
      } else {
        this.selectCoupon = coupon;
        this.selectCode = code;
      }
    },
    scrollMove(moveY) {
      var scroll = document.getElementById('orderScroll');
      scroll.scrollTop += moveY;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    //쿠폰 교환 상품 아이템
    mergeList() {
      let arr = this.posTransaction.PluInfoList.filter((item) => this.selectCoupon.CouponPluList.filter((item2) => item2.GoodsCode == item.PluCode).length > 0);
      return arr;
      // let result = arr.filter((item1, idx1) => {
      //   return (
      //     arr.findIndex((item2, idx2) => {
      //       return item1.DIS_ITEM_CD == item2.DIS_ITEM_CD;
      //     }) == idx1
      //   );
      // });

      // return result;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped>
@media (-webkit-device-pixel-ratio: 1.25) {
  .ft-point {
    font-size: 1.2em !important;
  }
}
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 74%;
  height: max-content;
  padding: 3.6vh 0 8vh;
  background: var(--bg-color);
  border-radius: var(--radius-modal);
}

.layer__header {
  height: max-content;
  text-align: center;
  width: 100%;
  padding: 0 4vw;
}

.layer__body {
  position: relative;
  min-height: 7.3vh;
  margin: 3vh 0;
  text-align: center;
}
/* common.css에 있는 .layer, .layer__header, .lyr-txt, .layer__body 클래스 스타일 변경 필수 */

.layer__body_coupon {
  margin: 1.3vh 0 3vh 0;
  padding: 0 var(--txt-pd30);
}

.payment-total {
  width: 100%;
}

.payment-total dl {
  display: flex;
  justify-content: center;
  height: 3.3vh;
  line-height: 3.3vh;
  margin-bottom: var(--pd-box);
}

.payment-total dt {
  padding-left: var(--txt-pd40);
  font-weight: 700;
}

.payment-total dd {
  padding-right: var(--txt-pd40);
  font-size: 1.8em;
  font-weight: 600;
}

.payment-total .pay-amount {
  width: 27vw;
  margin-left: var(--txt-pd40);
  text-align: right;
  border: 2px solid var(--border-color);
  border-radius: var(--radius);
}

.list-order--coupon {
  width: 100%;
  height: 29.2vh;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-modal);
  background-color: var(--light-gray);
  margin: var(--txt-pd40) 0;
  padding: var(--txt-pd50);
}

.coupon-list {
  width: 100%;
}

.coupon-item {
  position: relative;
  width: 100%;
  height: max-content;
  padding: 0.9vh 5.5vw 0.9vh 6.7vw;
  background: #fff;
  border-radius: var(--radius);
  box-shadow: rgba(0, 0, 0, 0.3) 0 8px 12px;
  border: 4px solid transparent;
}

.coupon-item.selected {
  border-color: #000;
}

.dark .coupon-item.selected {
  border-color: #fff;
}

.coupon-item + .coupon-item {
  margin-top: 1.3vh;
}

.coupon-item-top {
  width: 100%;
}

.coupon-name {
  width: 100%;
  height: 3.6vh;
  line-height: 1.8vh;
  text-align: left;
  text-overflow: ellipsis;
  font-size: 1.2em;
  font-weight: 600;
  word-wrap: break-word;
  word-break: keep-all;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.coupon-item-bottom {
  width: 100%;
  height: 2.5vh;
  line-height: 2.5vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.coupon-date {
  font-size: 1em;
  width: 50%;
  font-weight: normal;
  color: var(--dark-gray);
  text-align: left;
}

.coupon-discount {
  font-size: 1.6em;
  width: 50%;
  text-align: right;
}

.coupon-item .ico-checked {
  display: none;
}
.coupon-item.selected .ico-checked {
  display: block;
  position: absolute;
  top: var(--pd-box);
  left: var(--pd-box);
}

.no-data {
  position: absolute;
  width: max-content;
  height: 11.6vh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}

.no-data .txt {
  font-size: 1.6em;
  font-weight: 700;
  color: #afafaf;
}

.dark .no-data .txt {
  color: var(--primary-ft-color-dark);
}

.coupon-type {
  width: 100%;
  height: 2vh;
  text-align: left;
  text-overflow: ellipsis;
  font-size: 0.9em;
  font-weight: 600;
  word-wrap: break-word;
  word-break: keep-all;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.not-matched {
  background-color: rgb(54, 52, 62, 0.8);
  /* border: 4px solid transparent; */
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0.9vh 5.5vw 0.9vh 6.7vw;
  z-index: 3;
  border-radius: var(--radius);
}

.not-matched .msg {
  color: #fff;
  line-height: 6em;
  font-size: 1.2em;
}

.basket-item {
  position: relative;
  width: 100%;
  height: -moz-max-content;
  height: max-content;
  padding: 0.9vh 5.5vw 0.9vh 6.7vw;
  background: #fff;
  border-radius: var(--radius);
  box-shadow: rgba(0, 0, 0, 0.3) 0 8px 12px;
  border: 4px solid transparent;
}

.basket-item.selected {
  border-color: #000;
}

.basket-item.selected .ico-checked {
  display: block;
  position: absolute;
  top: var(--pd-box);
  left: var(--pd-box);
}

.basket-item-left {
  width: 50%;
  display: inline-block;
}

.basket-item-right {
  width: 50%;
  display: inline-block;
}

.basket-sales {
  text-align: right;
}

.basket-name {
  text-align: left;
}

.basket-prd {
  width: 100%;
  height: 3.6vh;
  line-height: 3.8vh;
  text-overflow: ellipsis;
  font-size: 1.2em;
  font-weight: 600;
  word-wrap: break-word;
  word-break: keep-all;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
